import { FilterColors, FilterFonts } from "../../../state/filter";
import {
	PageElementsFamily,
	PageSizeAtom,
	createLocation,
} from "../../../state/page";
import { ThemeContext, ThemeProvider } from "styled-components";

import { IsInFlexBoxContext } from "../../displayElements/Cell";
import { NeuroDivergentFontMultiplier } from "../../../state/accessibility";
import { IsPreviewGenerator } from "../../../state/ui";
import { StyledButton } from "../Button";
import { strings } from "@quickpoint.me/shared";
import { useContext } from "react";
import { useRecoilValue } from "recoil";

function FormButton({
	atomId,
	submitted,
	$disabled,
	pageIndex,
}: {
	atomId: number;
	submitted: boolean;
	$disabled: boolean;
	pageIndex: number;
}) {
	const key = createLocation(pageIndex, atomId);
	const elementData = useRecoilValue(PageElementsFamily(key)).data;
	const isInFlexBox = useContext(IsInFlexBoxContext);
	const filterColors = useRecoilValue(FilterColors);
	const fontMultiplier = useRecoilValue(NeuroDivergentFontMultiplier);
	const fonts = useRecoilValue(FilterFonts);
	const isPreviewer = useRecoilValue(IsPreviewGenerator);
	const pageSize = useRecoilValue(PageSizeAtom);
	const tapped = elementData.tapped;
	const theme = useContext(ThemeContext);

	const baseFontSize = pageSize.baseFontSize;
	return (
		<ThemeProvider theme={theme ? theme.button : {}}>
			<StyledButton
				$baseFontSize={baseFontSize}
				$baseFontSizeRaw={pageSize.baseFontSizeRaw}
				$disabled={$disabled}
				$elementIndex={atomId}
				$filterColors={filterColors}
				$fonts={fonts}
				$fontMultiplier={fontMultiplier}
				$isInFlexBox={isInFlexBox}
				$modifier={elementData.modifier}
				$onePercentHeight={pageSize.onePercentHeight}
				$onePercentWidth={pageSize.onePercentWidth}
				$pageSize={pageSize}
				$isInPortrait={!pageSize.landscape}
				$tapped={tapped}
				aria-hidden={!elementData.tapped}
				className={`${strings.css.pageElement}  Button`}
				data-atom-id={atomId}
				data-testid={`${isPreviewer ? "previewer:" : ""} form-button ${atomId}`}
			>
				{submitted ? "Signed Up!" : "Sign Up Here"}
			</StyledButton>
		</ThemeProvider>
	);
}

export default FormButton;
